export const WarningColors = {
  NONE: "none",
  SUCCESS: "success",
  WARNING: "warning",
  INFO: "info",
  ERROR: "error",
} as const;

type WarningColorsKeys = keyof typeof WarningColors;

export type WarningColor = (typeof WarningColors)[WarningColorsKeys];

export type TimeRange = { timeStart: Date; timeEnd: Date };

export interface PlottedTimeSerie {
  [key: string]: { value: number; span: number };
}
